import {SafeHtmlPipe} from "../pipes/safe-html/safe-html.pipe";
import { FilterPipe } from './../filter.pipe';
import { KeysPipe } from './../keys.pipe';
import { DefaultColumnComponent } from './default-column/default-column.component';
import {CommonModule} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {
  MissingTranslationHandler,
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
  TranslateParser
} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {SweetAlert2Module} from "@toverux/ngx-sweetalert2";
import {AlertModule, PaginationModule} from "ngx-bootstrap";
import {DropzoneModule} from "ngx-dropzone-wrapper";
import {TruncatePipe} from ".././truncate.pipe";
import {CommonAttachmentComponent} from "../common-attachment/common-attachment.component";
import {WidgetHumanBodyComponent} from "../widget-human-body/widget-human-body.component";
import {WelcomeMessageComponent} from './welcome-message/welcome-message.component';
import {ReportApprovalDetailsComponent} from '../report-approval-details/report-approval-details.component';
import {ApprovalPertmitToWorkPrintComponent} from './approval-pertmit-to-work-print/approval-pertmit-to-work-print.component';
import { PopoverModule } from 'ngx-bootstrap/popover';

// Import directives
import {
  ValidNumberDirective,
  NumberPadDirective,
  AssignmentStatusDirective,
  DateFormatDirective
} from "../directives";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SortOrderComponent } from './sort-order/sort-order.component';
import { SelectModule } from 'ng-select';

const APP_DIRECTIVES = [
  ValidNumberDirective,
  NumberPadDirective,
  AssignmentStatusDirective,
  DateFormatDirective
];

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DropzoneModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: "modal-content",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn",
    }),
    PaginationModule.forRoot(),
    AlertModule.forRoot(),
    TranslateModule,
    SelectModule,
    PopoverModule.forRoot()
  ],
  declarations: [
    CommonAttachmentComponent,
    ReportApprovalDetailsComponent,
    TruncatePipe,
    WidgetHumanBodyComponent,
    WelcomeMessageComponent,
    APP_DIRECTIVES,
    ApprovalPertmitToWorkPrintComponent,
    DefaultColumnComponent,
    KeysPipe,
    FilterPipe,
    SortOrderComponent,
    SafeHtmlPipe,
  ],
  entryComponents: [ApprovalPertmitToWorkPrintComponent],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    CommonAttachmentComponent,
    ReportApprovalDetailsComponent,
    TruncatePipe,
    WidgetHumanBodyComponent,
    PaginationModule,
    AlertModule,
    TranslateModule,
    APP_DIRECTIVES,
    DefaultColumnComponent,
    SortOrderComponent,
    KeysPipe,
    FilterPipe,
    SafeHtmlPipe,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [],
})
export class SharedModule {
}



// WEBPACK FOOTER //
// /app/src/app/shared/shared.module.ts